import { render, staticRenderFns } from "./CollectionImageShow.vue?vue&type=template&id=d9ae9cc6&"
import script from "./CollectionImageShow.vue?vue&type=script&lang=js&"
export * from "./CollectionImageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports